import React from "react";
import * as ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
//browser router para usar varias rutas en la app
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import store from "./initializers/store";
import LogRocket from "logrocket";
import { disableReactDevTools, GlobalDebug } from "./utils";

if (process.env.REACT_APP_ENV === "production") {
  disableReactDevTools();
}
if (process.env.REACT_APP_ENV !== "local") {
  LogRocket.init("5a1tcc/smartcatalog");
}

(process.env.REACT_APP_ENV === "production" ||
  process.env.REACT_APP_ENV === "STAGING") &&
  GlobalDebug(false);
const renderApp = (
  <BrowserRouter
    getUserConfirmation={(message, callback) => {
      const allowTransition = window.confirm(message);
      window.setTimeout(() => {
        callback(allowTransition);
      }, 1000);
    }}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);

const reactDomRender =
  typeof ReactDOM.render === "function"
    ? ReactDOM.render
    : ReactDOM.default && typeof ReactDOM.default.render === "function"
    ? ReactDOM.default.render
    : null;

if (!reactDomRender) {
  throw new Error("ReactDOM.render is not available in this build/runtime.");
}

reactDomRender(renderApp, document.getElementById("root"));

// Keep service worker disabled to avoid stale asset caches
// causing white screens after deployments.
serviceWorker.unregister();
